import React, { useState, useEffect } from "react";
import { ArrowUpIco } from "../../../../../modules/CustomIcons";




const ScrollToTop: React.FC = () => {

    const [isScrollToTopButton, setIsScrollToTopButton] = useState(false);
    const trackScrolling = () => {
        const wrappedElement = document.getElementsByClassName('layout_scroll')[0];

        if (wrappedElement.scrollTop) {
            setIsScrollToTopButton(true)
            //   document.removeEventListener('scroll', trackScrolling);
        } else {
            setIsScrollToTopButton(false)
        }
        
        // if (wrappedElement.scrollHeight - wrappedElement.scrollTop === wrappedElement.clientHeight) {
        //     setIsScrollToTopButton(true)
        //     //   document.removeEventListener('scroll', trackScrolling);
        // } else {
        //     setIsScrollToTopButton(false)
        // }
    }

    useEffect(() => {
        const layoutScroll = document.getElementsByClassName('layout_scroll')[0];
        layoutScroll.addEventListener('scroll', trackScrolling);
        return () => {
            layoutScroll.removeEventListener('scroll', trackScrolling);
        };
    }, []);


    const scrollToTop = () => {
        const layoutScroll = document.getElementsByClassName('layout_scroll')[0];
        layoutScroll.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <>
            {
                isScrollToTopButton ? <div className='scrollToTop full' onClick={scrollToTop}>
                    <ArrowUpIco className="scrollToTop__icon"/>
                </div> : <></>
            }
        </>
    )
}

export default ScrollToTop;
